import { Slider, useTheme } from '@mui/material';
import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  selectHueRotationOffset,
  setHueRotationOffset,
} from '../../map/mapSlice';

const BUCKET_MAX_SIZE = 360;

const HueRotationSlider: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const hueRotationOffset = useAppSelector(selectHueRotationOffset);

  const handleChangeColorsMerging = useCallback(
    (value: number | number[]) => {
      dispatch(setHueRotationOffset(value as number));
    },
    [dispatch]
  );

  return (
    <Slider
      sx={{
        width: '80%',
        m: '0 1rem',
        '&.Mui-disabled': {
          opacity: 0.3,
          color: theme.colors.darkTheme.grey.muted,
        },
      }}
      value={hueRotationOffset}
      step={1}
      min={0}
      max={BUCKET_MAX_SIZE}
      onChange={(event, value) => handleChangeColorsMerging(value)}
    />
  );
};

export default HueRotationSlider;
